import React, { useState } from "react";
import { Check, X, Pencil } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../lib/api";

export const EditableDateCell = ({ item, isSupervisor, onUpdated }) => {
  const [editing, setEditing] = useState(false);
  const [value, setValue] = useState("");
  const [saving, setSaving] = useState(false);

  const start = () => {
    const cur = item.gelis_tarihi || "";
    setValue(/^\d{4}-\d{2}-\d{2}$/.test(cur) ? cur : "");
    setEditing(true);
  };

  const save = async () => {
    if (!value || value === item.gelis_tarihi) {
      setEditing(false);
      return;
    }
    setSaving(true);
    try {
      const { data } = await api.put(`/inventory/${item.id}`, { gelis_tarihi: value });
      if (data.pending) {
        toast.success("Tarih değişikliği Supervisor onayına gönderildi");
      } else {
        onUpdated(data);
        toast.success("Giriş tarihi güncellendi");
      }
      setEditing(false);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSaving(false);
    }
  };

  if (!editing) {
    return (
      <button
        data-testid="inventory-row-date-edit"
        onClick={start}
        title={isSupervisor ? "Giriş tarihini düzenle" : "Giriş tarihi değişikliği talep et (Supervisor onayı)"}
        className="group inline-flex items-center gap-1.5 hover:text-[color:var(--primary)] transition-colors"
      >
        <span data-testid="inventory-row-date-value">{item.gelis_tarihi || "-"}</span>
        <Pencil size={11} className="opacity-0 group-hover:opacity-100 transition-opacity shrink-0" />
      </button>
    );
  }

  return (
    <div className="flex items-center gap-1">
      <input
        data-testid="inventory-row-date-input"
        type="date"
        autoFocus
        value={value}
        disabled={saving}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") save();
          else if (e.key === "Escape") setEditing(false);
        }}
        className="h-7 px-1 hard border border-[color:var(--primary)] bg-white text-xs outline-none"
      />
      <button
        data-testid="inventory-row-date-save"
        onClick={save}
        disabled={saving}
        title={isSupervisor ? "Kaydet" : "Onaya gönder"}
        className="p-1 hard bg-[color:var(--success)] text-white hover:opacity-90 disabled:opacity-50"
      >
        <Check size={12} strokeWidth={3} />
      </button>
      <button
        data-testid="inventory-row-date-cancel"
        onClick={() => setEditing(false)}
        disabled={saving}
        className="p-1 hard border border-[color:var(--border)] hover:bg-[color:var(--bg)] disabled:opacity-50"
      >
        <X size={12} strokeWidth={3} />
      </button>
    </div>
  );
};
